<template>
  <fieldset>
<!--    <legend>{{ pDictionary['dictionary.media.insertion'] }}</legend>-->
    <div>

      <input type="hidden" name="dataForm.data.mediaInsertionRef.id" v-model="mediaInsertionId"/>

      <!--
        - MEDIA PLAN
        -->
      <media-plan-select
          v-model="mediaPlanId"
          :p-currencies="pCurrencies"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-src="pSrc"
          :p-src-id="pSrcId"
          p-error-key="dataForm.data.projectRef"
          :p-required="true"
          p-input-name="dataForm.data.projectRef.id"
          p-select-container="#bsInvoiceSaveFormDialog"
          :p-disabled="false">
      </media-plan-select>

      <!--
       - CAMPAIGN
       -->
      <campaign-select
          v-model="campaignId"
          :p-currencies="pCurrencies"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-src="pSrc"
          :p-src-id="pSrcId"
          p-error-key="dataForm.data.campaignRef"
          p-input-name="dataForm.data.campaignRef.id"
          p-select-container="#bsInvoiceSaveFormDialog"
          :p-required="false"
          :p-disabled="campaignSelectDisabled"
          :p-data-list-input="campaignDataListInput">
      </campaign-select>

      <!--
        - ORGANIZATION SELECT
        -->
      <organization-select
          v-model="organizationIds"
          :p-currencies="pCurrencies"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-src="pSrc"
          :p-src-id="pSrcId"
          p-input-name="dataForm.organizationIds"
          p-error-key="dataForm.data.organizationRefs"
          p-select-container="#bsInvoiceSaveFormDialog"
          :p-required="true"
          :p-multiple="true"
          :p-disabled="organizationsSelectDisabled"
          :p-data-list-input="organizationDataListInput">
      </organization-select>

      <!--
       - ORGANIZATION PROFILE LIST
       -->
      <organization-profile-list
          :p-currencies="pCurrencies"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-src="pSrc"
          :p-src-id="pSrcId"
          :p-organization-ids="organizationIds">
      </organization-profile-list>
    </div>
  </fieldset>
</template>

<script>
import MediaPlanSelect from "@/components/mediaplan/mediaplan/MediaPlanSelect";
import CampaignSelect from "@/components/mediaplan/campaign/CampaignSelect";
import OrganizationSelect from "@/components/organization/organization/OrganizationSelect";
import refHelpers from '@/helpers/ref-helpers'
import OrganizationProfileList from "@/components/organization/OrganizationProfileList";

export default {
  name: "InvoiceSaveFormMediaInsertionSection",
  components: {MediaPlanSelect, CampaignSelect, OrganizationSelect, OrganizationProfileList},
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pInvoice: Object
  },
  data: function () {
    return {
      mediaInsertionId: refHelpers.getRefId(this.pInvoice.mediaInsertionRef, null),
      mediaPlanId: refHelpers.getRefId(this.pInvoice.projectRef, null),
      campaignId: refHelpers.getRefId(this.pInvoice.campaignRef, null),
      organizationIds: refHelpers.getRefIds(this.pInvoice.organizationRefs, [])
    }
  },
  computed: {
    hasMediaInsertion: function() {
      return refHelpers.isValidRef(this.pInvoice.mediaInsertionRef)
    },
    campaignSelectDisabled: function() {
      return !refHelpers.isValidRefId(this.mediaPlanId);
    },
    campaignDataListInput: function() {
      return {
        projectIds: [this.mediaPlanId || -1],
        groupBy: 'S-8' // MediaPlanDefinition.TOKEN
      }
    },
    organizationsSelectDisabled: function() {
      return !refHelpers.isValidRefId(this.mediaPlanId);
    },
    organizationDataListInput: function() {
      return {
        projectIds: [this.mediaPlanId || -1],
        campaignIds: [this.campaignId || null],
        groupBy: 'S-30' /* OrganizationGroupDefinition.TOKEN */
      };
    }
  },
  watch: {
    "pInvoice.mediaInsertionRef": function (newValue) {
      this.mediaInsertionId = refHelpers.getRefId(newValue, null);
    },
    mediaPlanId: function(mediaPlanId) {
      this.$emit('invoice-mediaplan-updated', mediaPlanId);
    },
    campaignId: function(campaignId) {
      this.$emit('invoice-campaign-updated', campaignId);
    },
    organizationIds: function(organizationIds) {
      this.$emit('invoice-organizations-updated', organizationIds);
    }
  }
}
</script>

<style scoped>

</style>